import { mergeStyleSets } from '@uifabric/merge-styles';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: '1rem',
    fontWeight: 400,
  },
});
